<a *ngIf="isRouterLink" [target]="eLinkTargetType" (click)="click($event)" class="anchor-tag">
  <nuc-icon *ngIf="linkIcon" [iconClass]="linkIcon"></nuc-icon>
  <button mat-button [ngClass]="styleClass" [disabled]=disabled
    [attr.data-aue-prop]="styleClass?.includes('footer-link-button') ? 'label' : null"
    [attr.data-aue-type]="styleClass?.includes('footer-link-button') ? 'text' : null"
    [attr.data-aue-label]="styleClass?.includes('footer-link-button') ? 'footerLinkName' : null">{{ text }}</button>
</a>
<a *ngIf="!isRouterLink && eLinkTargetType !== eLinkButtonTarget.NEW_WINDOW" [href]="href" [target]="eLinkTargetType"
  class="anchor-tag">
  <nuc-icon *ngIf="linkIcon" [iconClass]="linkIcon"></nuc-icon>
  <button mat-button [ngClass]="styleClass" [disabled]=disabled
    [attr.data-aue-prop]="styleClass?.includes('footer-link-button') ? 'label' : null"
    [attr.data-aue-type]="styleClass?.includes('footer-link-button') ? 'text' : null"
    [attr.data-aue-label]="styleClass?.includes('footer-link-button') ? 'footerLinkName' : null">{{ text }}</button>
</a>
<a *ngIf="eLinkTargetType=== eLinkButtonTarget.NEW_WINDOW" (click)="click($event)" class="anchor-tag">
  <nuc-icon *ngIf="linkIcon" [iconClass]="linkIcon" [displayClass]="iconStyleClass" [color]="iconColor"
    [size]="sizeClassValue"></nuc-icon>
  <button mat-button [ngClass]="styleClass" [disabled]=disabled
    [attr.data-aue-prop]="styleClass?.includes('footer-link-button') ? 'label' : null"
    [attr.data-aue-type]="styleClass?.includes('footer-link-button') ? 'text' : null"
    [attr.data-aue-label]="styleClass?.includes('footer-link-button') ? 'footerLinkName' : null">
    {{ text }}</button>
</a>